
import axios from "axios";
const BASE = process.env.REACT_APP_ENGLISH_TUTORIAL_API;

export const getModules = () =>
  axios.get(`${BASE}/modules`).then((r) => r.data.modules);

export const getModuleTutorials = (moduleId) =>
  axios.get(`${BASE}/modules/${moduleId}/tutorials`).then((r) => r.data);

export const markTutorialComplete = (tutorialId, completed = true) =>
  axios
    .post(`${BASE}/tutorials/${tutorialId}/complete`, { completed })
    .then((r) => r.data);

export const getModuleQuiz = (moduleId) =>
  axios.get(`${BASE}/modules/${moduleId}/quiz`).then((r) => r.data);

export const submitQuiz = (moduleId, answers) =>
  axios.post(`${BASE}/modules/${moduleId}/quiz/submit`, { answers }).then((r) => r.data);
